import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sarlaft',
  templateUrl: './sarlaft.component.html',
  styleUrls: ['./sarlaft.component.css']
})
export class SarlaftComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
